import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {GlobalDataService} from '../../../../../shared/services/global-data.service';

@Component({
  selector: 'pv-common-mission-contact-dialog',
  templateUrl: './common-mission-contact-dialog.component.html',
  styleUrls: ['./common-mission-contact-dialog.component.scss']
})
export class CommonMissionContactDialogComponent implements OnInit {

  public availableTitles: any;

  @Input() title: string;
  @Input() firstName: string;
  @Input() lastName: string;
  @Output() submitEvent = new EventEmitter();

  constructor(protected dialogRef: NbDialogRef<CommonMissionContactDialogComponent>,
              private globalDataService: GlobalDataService,) { }

  ngOnInit(): void {
    this.availableTitles = this.globalDataService.getPersonTitles();
  }

  submit() {
    const title = this.title;
    const firstName = this.firstName;
    const lastName = this.lastName;

    this.submitEvent.emit({title, firstName, lastName});
  }

}
